import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const useWorkspaceStore = create()(persist((set) => ({
    selectedWorkspaceId: null,
    selectedWorkspaceName: null,
    selectWorkspace: (id, name) => set({ selectedWorkspaceId: id, selectedWorkspaceName: name }),
    clearWorkspace: () => set({ selectedWorkspaceId: null, selectedWorkspaceName: null }),
}), {
    name: 'workspace-storage',
}));
